import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "@/App";
import Admin from "@/Admin";
import { ServicesPage, AboutPage, BlogPage, BlogPostPage, CRMSolutionsPage, OffshoreTeamsPage, IndustriesPage, ContactPage } from "@/Pages";

const tree = (
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<Admin />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/crm-solutions" element={<CRMSolutionsPage />} />
        <Route path="/offshore-teams" element={<OffshoreTeamsPage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

const rootEl = document.getElementById("root");
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootEl, tree);
} else {
  ReactDOM.createRoot(rootEl).render(tree);
}
